<template lang="html">
  <div class="c-e2e-not-found">
    <template v-if="type=='image'" class="">
      <div class="e2e-not-found-container">
        <div><img v-if="type == 'image'" :src='imgTableSrc' alt srcset :style="'height: '+height+';'"/></div>
        <div style="font-size: 14px;color: #999;">
            <span v-if="$slots.default">
                <slot></slot>
            </span>
            <span v-else>{{$t('system.no_data')}}</span>
        </div>
      </div>
    </template>

    <template v-if="type == 'text'" class="">
      <div class="e2e-not-found-container">{{$t('system.no_data')}}</div>
    </template>

  </div>
</template>

<script>

export default {
  data() {
    return {
      imgTableSrc: require('@/assets/no_data.png')
    };
  },
  props: {
    type: {
      type: String, // 可以传入 table / text / file ，对应文字版的not found 和图片版的not found file||table
      default: 'image',
      validator: function(value) {
        return ['image', 'text'].indexOf(value) !== -1;
      }
    },
    height: String
  },
  methods: {},
  mounted() {

  }
};
</script>

<style lang="less" scoped>
  .c-e2e-not-found {
    width: 100%;
    position: relative;
    z-index: 2;

    .e2e-not-found-container {
      padding: 20px;
      text-align: center;

    }
  }
</style>



// WEBPACK FOOTER //
// NoDataFound.vue?11c06f3e